import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Calendar, ExternalLink } from 'lucide-react';
import { useSectionData } from '../hooks/useSectionData';
import { fetchHackathons, attr } from '../services/api';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
}

export default function Hackathons() {
  const items = useSectionData(fetchHackathons);
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  if (!items) return null;

  return (
    <section id="hackathons" ref={ref} className={`section${inView ? ' visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <p className="section-label">hackathons</p>
          <h2 className="section-title">Hackathons</h2>
          <div className="section-line" />
        </header>

        <div className="events-grid">
          {items.map((item, i) => {
            const a = attr(item);
            return (
              <div key={i} className="event-card">
                <p className="event-name">{a.name}</p>
                {a.result && (
                  <span className="hackathon-result">{a.result}</span>
                )}
                <div className="event-meta">
                  {a.date && (
                    <span><Calendar size={11} /> {fmtDate(a.date)}</span>
                  )}
                  {a.organizer && <span>by {a.organizer}</span>}
                </div>
                {a.project_name && (
                  <p className="event-desc" style={{ fontStyle: 'italic' }}>
                    Project: {a.project_name}
                  </p>
                )}
                {a.description && <p className="event-desc">{a.description}</p>}
                {a.url && (
                  <a
                    href={a.url}
                    target="_blank"
                    rel="noreferrer noopener"
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: '0.8rem', color: 'var(--accent)', marginTop: 6 }}
                  >
                    <ExternalLink size={12} /> Details
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
